// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610201455/js/" + chunkId + "." + {"44":"260e700f","225":"0f0c66cc","481":"992c2f44","486":"63cfe828","770":"d55d4af1"}[chunkId] + ".0.45462027388798043.chunk.js";
};